import { SignJWT } from "jose";

export async function generateWidgetToken(
  widgetSecret: string,
  params: { userId: string; userName: string; ttlSeconds: number }
): Promise<string> {
  const { userId, userName, ttlSeconds } = params;
  const key = new TextEncoder().encode(widgetSecret);
  return new SignJWT({ name: userName })
    .setProtectedHeader({ alg: "HS256" })
    .setSubject(userId)
    .setIssuedAt()
    .setExpirationTime(`${ttlSeconds}s`)
    .sign(key);
}
